module.exports = __webpack_public_path__ + "media/images/user-da27cf0536b1378d2db4e59b922b2e18.png";